import { render, staticRenderFns } from "./show.page.vue?vue&type=template&id=3f30aca6&scoped=true&"
import script from "./show.page.vue?vue&type=script&lang=ts&"
export * from "./show.page.vue?vue&type=script&lang=ts&"
import style0 from "./show.page.vue?vue&type=style&index=0&id=3f30aca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f30aca6",
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator,QCard,QCardSection});
